module.exports = __webpack_public_path__ + "img/ueber-mich-1_1596.9b0c0d25.webp";